enum FormMode {
  Add,
  Edit,
}

export default FormMode;
